// src/telemetry/capabilitiesReporter.ts
import { collectCapabilities } from "./capabilities.ts";

const REPORT_LS_KEY = "gc_caps_cached_report";

function cacheReport(report: any) {
    try { localStorage.setItem(REPORT_LS_KEY, JSON.stringify(report)); } catch { }
    (window as any).gc = (window as any).gc || {};
    (window as any).gc.capabilities = report;
}

export function getCachedReport<T = any>(): T | null {
    try {
        const raw = localStorage.getItem(REPORT_LS_KEY);
        return raw ? (JSON.parse(raw) as T) : null;
    } catch {
        return null;
    }
}

let _inflight: Promise<void> | null = null;

/**
 * Collects capabilities (no network), caches them, then resolves.
 */
export function initCapabilitiesReporting(opts: {
    appVersion?: string | null;
    extra?: Record<string, any>;
    deferIdle?: boolean;
    uniqueId: string; // required now
}): Promise<void> {
    const appVersion = opts.appVersion ?? null;
    const extra = opts.extra ?? {};
    const deferIdle = opts.deferIdle !== false;
    const uniqueId = opts.uniqueId;

    if (_inflight) return _inflight;
    if (!uniqueId) {
        console.error("No uniqueId provided to initCapabilitiesReporting");
        return Promise.resolve();
    }

    const run = async () => {

        const base = await collectCapabilities();
        const report = { ...base, meta: { appVersion, uniqueId, ...extra } };
        cacheReport(report);
    };

    if (deferIdle) {
        _inflight = new Promise<void>((resolve) => {
            const ric: any = (window as any).requestIdleCallback || ((cb: () => void) => setTimeout(cb, 0));
            ric(() =>
                setTimeout(() => {
                    run().then(resolve).catch(() => resolve());
                }, 0)
            );
        });
    } else {
        _inflight = run().then(() => { }).catch(() => { });
    }
    return _inflight;
}
